//React
import React from 'react';
import ReactDOM from 'react-dom';
import Dialog from 'material-ui/Dialog';
import logo from './images/nifc-logo-small.png';
import Bowser from "bowser";
// Redux
import { Provider } from 'react-redux'

import { PersistGate } from 'redux-persist/integration/react';
import configureStore from './redux/configureStore';

// React Router
import { createBrowserHistory } from 'history'
import { Router, Route } from 'react-router-dom';

// Material UI
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import theme from './muiTheme';

import Api from './services/api';
import App from './components/App';
// import Splash from './components/Splash';
import './index.css';


// URLSearchParams Polyfill
const URLSearchParams = require('url-search-params');
if (!window.URLSearchParams) {
  window.URLSearchParams = URLSearchParams;
}

if (!Array.from){
  Array.from = require('array-from');
}

if (!Array.prototype.includes) {
  /*eslint no-extend-native: ["error", { "exceptions": ["Array"] }]*/
  Object.defineProperty(Array.prototype, 'includes', {
    value: function(searchElement, fromIndex) {

      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      // 1. Let O be ? ToObject(this value).
      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If len is 0, return false.
      if (len === 0) {
        return false;
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0;

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
      }

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(searchElement, elementK) is true, return true.
        if (sameValueZero(o[k], searchElement)) {
          return true;
        }
        // c. Increase k by 1.
        k++;
      }

      // 8. Return false
      return false;
    }
  });
}

window.api = new Api();
const basename = process.env.PUBLIC_URL;

export const history = createBrowserHistory({ basename });
const { store, persistor } = configureStore();

const browser = Bowser.getParser(window.navigator.userAgent);
const isValidBrowser = browser.satisfies({
  chrome: ">=65.0.3325",
  edge: ">=65.0.3325",
  firefox: ">=31"
});

const browserHandler = (isValidBrowser) ? (<Route path='/' component={App} />) : (
  <Dialog
    modal={true}
    open={true}
    contentStyle={{width: '450px'}} >
    <div>
      <div style={{textAlign: 'center'}}>
        <img src={logo} width="120px" alt="National Interagency Fire Center" />
        <p>InFORM Inspector has been optimized to work with Chromium-based browsers, and may not perform adequately with other browsers. </p>
        <p>You can download Google Chrome by clicking on the link below.</p>
        <a href="https://www.google.com/chrome">
        <img src="https://www.google.com/intl/en/images/logos/chrome_logo.gif" alt="Google Chrome" />
        </a>

      </div>
    </div>
  </Dialog>
);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router basename={basename} history={history}>
        <MuiThemeProvider muiTheme={theme}>
           { browserHandler }
        </MuiThemeProvider>
      </Router>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
)
